import React, { useState } from 'react';
import Tickets from '../../Tickets';
import { OpenButton } from './styles';

type Props = {
  callId: string;
  integrationId: string | number;
  externalContactId: string;
};

export default function ModalTickets(props: Props) {
  const { integrationId, callId, externalContactId } = props;

  const [open, setOpen] = useState(false);

  return (
    <div>
      <OpenButton
        data-test-id="open-tickets-button"
        variant="text"
        onClick={() => setOpen(!open)}>
        Tickets
      </OpenButton>

      <Tickets
        open={open}
        onClose={() => setOpen(!open)}
        // @ts-ignore
        integrationId={integrationId}
        externalId={externalContactId}
        callId={callId}
      />
    </div>
  );
}
